// extracted by mini-css-extract-plugin
export var container = "styles-module--container--I0Rsc";
export var content = "styles-module--content--Wp6Vh";
export var headline = "styles-module--headline--EjTM1";
export var nav = "styles-module--nav--bj9ew";